import React, { useEffect } from 'react';
import { Box, Paper, CircularProgress } from '@mui/material';
import { useState, Downgraded } from '@hookstate/core';
import DataList from './dataList/dataList';
import { FULL_PERMISSION } from '../../constants/Constant';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import { useEventState } from '../../stores/eventStore';
import Helper from '../../utility/helper';
import ConfirmationDialog from '../../sharedcomponents/confirmationdialog/confirmationDialog';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import UserListDialog from './userListDialog';
import AddEventHomeDetail from './addEventHomeDetail';
import ViewHomeDetailDialog from './viewHomeDetailDialog';
const EventHomeDetailList = (props) => {
    const loading = useState(false);
    const openNotification = useState(false);
    const editNotificationInfo = useState();
    const [modPermission, setModPermission] = React.useState(null);
    const eventState = useEventState();
    const allData = useState([]);
    const eventData = useState(null);
    const userData = useState(null);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const isView = useState(false);
    const currentNotification = useState({});
    const overallParticipants = useState([]);
    const filteredParticipants = useState([]);
    const filteredAddParticipants = useState([]);
    const addedParticipants = useState([]);
    const openAddParticipantDialog = useState(false);
    const deleteConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const sendConfirmation = useState({
        open: false,
        title: '',
        message: '',
    });
    const [progress, setProgress] = React.useState(0);
    const [showCustomLoaderForEmail, setshowCustomLoaderForEmail] =
        React.useState(false);
    const [customNotificationID, setCustomNotificationID] = React.useState(0);
    const openViewHomeDetailDialog = useState(false);
    const [selectedViewParticipantData, setSelectedViewParticipantData] = React.useState([]);
    const [selectedViewParticipants, setSelectedViewParticipants] = React.useState([]);


    useEffect(() => {
        const userInfo = Helper.getStorage('userInfo');
        if (eventState && eventState.eventDetail.get()) {
            if (Helper.isAdminUser(userInfo)) {
                setModPermission(FULL_PERMISSION);
            } else if (userInfo.roles && Helper.isEventAdmin(userInfo)) {
                setModPermission(FULL_PERMISSION);
            }
        }
        // console.log("data");

    }, [eventState]);
    useEffect(() => {
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');
        if (
            eventData.get() == null ||
            (eventData.get() && eventData.eventID.value != eventInfo.eventID)
        ) {
            eventData.set(eventInfo);
            userData.set(userInfo);
        }

        ApiHelper.get(
            APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(
                eventData.get().eventID
            )
        ).then((res) => {
            let participantData = [];
            res.data.rows.map((item) => {
                participantData.push({ ...item, selected: false });
            });
            overallParticipants.set(participantData);
        });
        // console.log("data1");
    }, []);

    useEffect(() => {
        getEventHomeDetails();
    }, []);
    const getEventHomeDetails = () => {
        loading.set(true);
        let participantList = [];
        let activityData = [];
        ApiHelper.get(APIURLConstants.GET_HOME_DETAILS(eventData.get().eventID))
            .then((res) => {
                // console.log("res",res);
                let allNotification;

                if (res.data.length > 0) {
                    allNotification = res;

                    res.data.map((item) => {
                        if (item.isDelete === false) {
                            item.participants.length > 0 && item.participants.map((user) => {
                                participantList.push(user);
                            });

                            activityData.push({
                                actualData: item,
                                row: [
                                    {
                                        label: 'checkbox',
                                        key: 'homeDetailId',
                                        homeDetailId: item.homeDetailId,
                                        width: '0.03',
                                        inColumn: true,
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'Name',
                                        key: 'message',
                                        message: item.title,
                                        showLabel: false,
                                        width: '0.9',
                                        inColumn: true,
                                        showDetails: true,
                                        createdDate:
                                            Helper.FormatDate(
                                                item.createdDate
                                            ) +
                                            ' @ ' +
                                            Helper.FormatTime(item.createdDate),
                                        createdBy: item.createdByName,
                                    },
                                    {
                                        label: 'Action',
                                        key: 'viewHomeDetail',
                                        viewHomeDetail: 'View Home Detail',
                                        width: '0.02',
                                        inColumn: true,
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'Action',
                                        key: 'addParticipants',
                                        addParticipants: 'Add Participants',
                                        width: '0.02',
                                        inColumn: true,
                                        alignCenter: true,
                                    },
                                    {
                                        label: 'Action',
                                        key: 'participants',
                                        participants: 'Participants',
                                        count:
                                            item.participants != null
                                                ? item.participants.length
                                                : 0,
                                        width: '0.02',
                                        inColumn: true,
                                    },
                                    {
                                        label: 'Action',
                                        key: 'edit',
                                        edit: 'Edit',
                                        width: '0.02',
                                        inColumn: true,
                                    },
                                ],
                                selected: false,
                            });
                        }
                    });
                } else {
                    activityData = [];
                }
                addedParticipants.set(participantList);
                props.getSentData(allNotification);

                loading.set(false);
            })
            .catch((err) => {
                console.log(err);
                loading.set(false);
                props.getSentData(null);
            });
        allData.set(activityData);
    };
    const redirectToCreate = () => {
        openNotification.set(true);
    };

    const editNotification = (item) => {
        editNotificationInfo.set(item.actualData);
        openNotification.set(true);
    };
    const handleClose = () => {
        openNotification.set(false);
        editNotificationInfo.set(null);
    };
    const handleCloseViewHomeDetail = () => {
        setSelectedViewParticipantData([])
        setSelectedViewParticipants([])
        openViewHomeDetailDialog.set(false);
    };
    const handleViewHomeDetails = (item) => {

        let newFilterParticipant = overallParticipants.attach(Downgraded).get().filter(function (cv) {
            return item && item.actualData.participants.find(function (e) {
                return e.userID == cv.userID;
            });
        });
        setSelectedViewParticipants(newFilterParticipant);
        setSelectedViewParticipantData(item.actualData);
        openViewHomeDetailDialog.set(true);
    }
    const deleteNotification = () => {
        const selected = allData.get().filter((user) => user.selected === true);
        if (selected.length === 0) {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select Event Home Detail first',
            });
        } else {
            let message =
                selected.length == allData.get().length
                    ? 'Do you want to delete all Event Home Details?'
                    : 'Do you want to delete selected Event Home Detail?';

            deleteConfirmation.set({
                open: true,
                title: '',
                OkButtonText: 'Ok',
                message: message,
            });
        }
    };

    const handleConfirmation = () => {
        let deleteNotification = [];
        allData.get().map((notification) => {
            if (notification.selected === true) {
                deleteNotification.push(notification.actualData.homeDetailID);
            }
        });
        ApiHelper.post(APIURLConstants.DELETE_HOME_DETAIL, {
            eventID: eventData.get().eventID,
            ids: deleteNotification,
            modifiedBy: userData.get().userID,
        })
            .then((res) => {
                if (res.data) {
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Request deleted successfully',
                    });
                    getEventHomeDetails();
                }
            })
            .catch((error) => {
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while deleting request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
        deleteConfirmation.set({
            open: false,
            title: '',
            OkButtonText: 'Ok',
            message: '',
        });
    };

    const handleAddParticipants = (notes) => {
        currentNotification.set(notes);
        let newFilterParticipant = overallParticipants.attach(Downgraded).get().filter(function (cv) {
            return !addedParticipants.attach(Downgraded).get().find(function (e) {
                return e.userID == cv.userID;
            });
        });
        filteredAddParticipants.set(newFilterParticipant);
        openAddParticipantDialog.set(true);

    };

    const sendPushNotification = (selectedUsers) => {
        const AppNotificationData = {
            userIDs: selectedUsers.toString(),
            appNotificationTypeID: 8,
            eventID: eventData.get().eventID,
            moduleID: 19,
            recordRefID: 0,
            requestStatus: 2,
            status: 0,
            createdBy: userData.attach(Downgraded).get().userID,
        };
        ApiHelper.post(
            APIURLConstants.SAVE_APP_NOTIFICATION,
            AppNotificationData
        )
            .then((response) => {
                // console.log('res1', response);
                selectedUsers.map((val) => {
                    ApiHelper.get(
                        APIURLConstants.GET_MOBILE_PUSH_NOTIFICATION(
                            val,
                            Number(eventData.get().eventID),
                            eventData.get().eventName,
                            'Home',
                            'Published'
                        )
                    ).then((res1) => {
                        //console.log(res1);
                    });
                });
            })
            .catch((err) => {
                console.log('err', err);
            });
    };

    function getNotificationParticipants(id) {
        // console.log(id);
        return ApiHelper.get(APIURLConstants.GET_EVENT_HOME_DETAIL_PARTICIPANTS(id))
            .then((participants) => {
                return participants.data;
            })
            .catch((err) => {
                console.log(err);
            });
    }
    const addParticipants = (selectedUsers) => {
        if (selectedUsers.length === 0) {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select participants first',
            });
        } else {
            let notification = currentNotification.attach(Downgraded).get();
            // console.log(notification);
            let obj = {
                homeDetailID: notification.actualData.homeDetailID,
                createdBy: userData.attach(Downgraded).get().userID,
                participants: selectedUsers,
            };
            ApiHelper.post(APIURLConstants.POST_EVENT_HOME_DETAIL_PARTICIPANTS, obj)
                .then((res) => {
                    if (res) {
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'success',
                            message: 'Participants added successfully.',
                        });
                        openAddParticipantDialog.set(false);
                        getEventHomeDetails();
                        let filteredIds = overallParticipants
                            .attach(Downgraded)
                            .get().filter((elem) => elem.isPublished === true && elem.userID == selectedUsers.toString()
                            ).map((x) => x.userID)
                        if (filteredIds.length > 0) {
                            sendPushNotification(filteredIds);
                        }
                    } else {
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'error',
                            message: 'Something went wrong.',
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);

                    setSnackBarProps({
                        openSnack: true,
                        variant: 'error',
                        message: 'Something went wrong.',
                    });
                });
        }
    };
    const handleViewParticipants = (notification) => {
        currentNotification.set(notification);
        isView.set(true);
        ApiHelper.get(
            APIURLConstants.GET_EVENT_HOME_DETAIL_PARTICIPANTS(
                notification.actualData.homeDetailID
            )
        )
            .then((participants) => {
                let ids = participants.data.map((x) => x.userID);
                let allParticipants = overallParticipants
                    .attach(Downgraded)
                    .get();
                let userList = allParticipants.filter((x) =>
                    ids.includes(x.userID)
                );
                filteredAddParticipants.set(userList);
                openAddParticipantDialog.set(true);
            })
            .catch((err) => {
                console.log(err);
                setSnackBarProps({
                    openSnack: true,
                    variant: 'error',
                    message: 'Something went wrong.',
                });
            });
    };

    const handleCloseAddParticipant = () => {
        openAddParticipantDialog.set(false);
        isView.set(false);
    };
    const deleteParticipants = (selectedUsers) => {
        if (selectedUsers.length === 0) {
            setSnackBarProps({
                snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select participants first',
            });
        } else {
            const userInfo = Helper.getStorage('userInfo');
            let notification = currentNotification.attach(Downgraded).get();
            let obj = {
                eventID: eventData.get().eventID,
                homeDetailId: notification.actualData.homeDetailID,
                modifiedBy: userInfo.userID,
                Ids: selectedUsers,
            };
            deleteNotificationParticipants(obj)
                .then((res) => {
                    if (res) {
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'success',
                            message: 'Participants deleted successfully.',
                        });
                        getEventHomeDetails();
                        openAddParticipantDialog.set(false);
                        isView.set(false);
                    } else {
                        setSnackBarProps({
                            openSnack: true,
                            variant: 'error',
                            message: 'Something went wrong.',
                        });
                    }
                })
                .catch((err) => {
                    console.log(err);

                    setSnackBarProps({
                        openSnack: true,
                        variant: 'error',
                        message: 'Something went wrong.',
                    });
                });
        }
    };

    function deleteNotificationParticipants(obj) {
        return ApiHelper.post(APIURLConstants.DELETE_HOME_DETAIL_PARTICIPANTS, obj)
            .then((result) => {
                return result.data;
            })
            .catch((err) => {
                console.log(err);
            });
    }

    return (
        <Box sx={{ width: '100%' }}>
            {loading.get() ? (
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '100%',
                        width: '100%',
                        marginTop: '15%',
                    }}>
                    <CircularProgress />
                </Box>
            ) : (
                <Box>
                    <Paper sx={{ width: '100%', mb: 2, boxShadow: 'none' }}>
                        <DataList
                            showSearch={true}
                            data={allData.attach(Downgraded).get()}
                            title={''}
                            handleClick={redirectToCreate}
                            buttonTitle={'Add'}
                            modPermission={modPermission}
                            searchLabel={'Search'}
                            deleteRows={deleteNotification}
                            editRow={editNotification}
                            handleAddParticipants={handleAddParticipants}
                            handleViewParticipants={handleViewParticipants}
                            customLoaderForEmail={showCustomLoaderForEmail}
                            progressValue={progress}
                            customNotificationID={customNotificationID}
                            handleViewHomeDetails={handleViewHomeDetails}

                        />
                    </Paper>
                    {openNotification.get() && (
                        <AddEventHomeDetail
                            notesInfo={editNotificationInfo
                                .attach(Downgraded)
                                .get()}
                            title="Event Home Settings"
                            open={openNotification.get()}
                            handleClose={handleClose}
                            getEventHomeDetails={getEventHomeDetails}
                            setSnackBarProps={setSnackBarProps}
                        />
                    )}
                </Box>
            )}
            {openAddParticipantDialog.get() && (
                <UserListDialog
                    title={
                        !isView.get() ? 'ADD PARTICIPANTS' : 'VIEW PARTICIPANTS'
                    }
                    addParticipants={addParticipants}
                    open={openAddParticipantDialog.get()}
                    deleteParticipants={deleteParticipants}
                    handleClose={handleCloseAddParticipant}
                    users={filteredAddParticipants.attach(Downgraded).get()}
                    isView={isView.get()}
                    selectAllCheckBox={true}
                />
            )}
            {
                <ConfirmationDialog
                    open={deleteConfirmation.get().open}
                    message={deleteConfirmation.get().message}
                    OkButtonText={deleteConfirmation.get().OkButtonText}
                    handleCnfClick={() =>
                        handleConfirmation(deleteConfirmation)
                    }
                    onCancelClick={() => {
                        deleteConfirmation.set({
                            ...deleteConfirmation.get(),
                            open: false,
                        });
                    }}></ConfirmationDialog>
            }

            {openViewHomeDetailDialog.get() && (
                <ViewHomeDetailDialog
                    title={'View Home Detail'}
                    data={selectedViewParticipantData}
                    open={openViewHomeDetailDialog.get()}
                    handleClose={handleCloseViewHomeDetail}
                    users={selectedViewParticipants}
                />
            )}

            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
            {/* <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={openBackdrop}
            >
                {/* <CircularProgress color="inherit" /> */}
            {/*  <CircularProgressWithLabel value={progress} />;
            </Backdrop> */}
        </Box>
    );
};

export default EventHomeDetailList;
